import ApiClient from '@/services/ApiClient/ApiClient'
import { AppConfig } from '@/config/config'

export default new ApiClient({ baseUrl: AppConfig.GATEWAY_AUDIT_URL })
